//营销管理
export default [
  {
    path: "/groups",
    component: () => import("../pages/marketingManage/groups.vue"),
    name: "groups",
    title: "团购管理",
    meta: {
      title: "团购管理",
    },
  },
  {
    path: "/groupsOrder",
    component: () => import("../pages/marketingManage/groupsOrder.vue"),
    name: "groupsOrder",
    title: "团购订单",
    meta: {
      title: "团购订单",
    },
  },

  // 推文活动设置管理
  {
    path: "/shareActivity",
    component: (resolve) =>
      require([
        "../pages/marketingManage/shareActivity/shareActivity.vue",
      ], resolve),
    name: "shareActivity",
    title: "推文设置管理",
    meta: {
      title: "推文设置管理",
    },
  },
  // 推文活动记录管理
  {
    path: "/shareActivityRecords",
    component: (resolve) =>
      require([
        "../pages/marketingManage/shareActivityRecords/shareActivityRecords.vue",
      ], resolve),
    name: "shareActivityRecords",
    title: "推文记录管理",
    meta: {
      title: "推文记录管理",
    },
  },
];
